import React, { Component } from "react";

import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import ReactAwesomePlayer from 'react-awesome-player'
import {
    createStyles,
    Text,
    Avatar,
    TypographyStylesProvider,
    Paper,
    ActionIcon,
    Image,
    Group,
    Card,
    Button,
    NumberInput
} from '@mantine/core';

import {
    IconFlag,
    IconCornerDownRight,
    IconSquareRoundedArrowUp,
    IconTrendingUp,
    IconCheck,
    IconX
} from '@tabler/icons';

import pagani from '../assets/pagani.jpg';
import porsche_video_720 from '../assets/porsche_video_720.mp4';
//video source: Video by <a href="https://pixabay.com/users/wowfactorfilms-13980848/?utm_source=link-attribution&amp;utm_medium=referral&amp;utm_campaign=video&amp;utm_content=28039">wowfactorfilms</a> from <a href="https://pixabay.com//?utm_source=link-attribution&amp;utm_medium=referral&amp;utm_campaign=video&amp;utm_content=28039">Pixabay</a>


const useStyles = createStyles((theme) => ({
    msg: {
        textAlign: 'center'
    }
}));



//needed:doc only a message property is needed
export function VideoPlayerCard({message}){
    const { classes } = useStyles();
    
    let playerOptions ={
        poster: pagani,
        sources: [
            {
                type: "video/mp4",
                src: porsche_video_720
            }
        ]
    }
    function loadeddata() {
        console.log('loadeddata')
    }
    function canplay() {
        console.log('canplay')
    }
    function canplaythrough() {
        console.log('canplaythrough')
    }
    function play() {
        console.log('play')
    }
    function pause() {
        console.log('pause')
    }
    function waiting() {
        console.log('waiting')
    }
    function playing() {
        console.log('playing')
    }
    function ended() {
        console.log('ended')
    }
    function error() {
        console.log('error')
    }
    
    
    return (
        <>
            <Card shadow="sm" p="lg" radius="md">
                <Card.Section>
                    <ReactAwesomePlayer
                        onRef={video => { console.log(video) }}
                        options={playerOptions}
                        loadeddata={loadeddata}
                        canplay={canplay}
                        canplaythrough={canplaythrough}
                        play={play}
                        pause={pause}
                        waiting={waiting}
                        playing={playing}
                        ended={ended}
                        error={error}
                    />
                </Card.Section>
                <br/>
                <iframe width="400" height="225" src="https://www.youtube.com/embed/bjhgYpMuqbc" title="Fatboy Eats - Brighton Rooftop B2B Set!" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                <iframe width="400" height="225" src="https://www.youtube.com/embed/omJTGq6bElA" title="Superbird, Daytona, Mustangs and Mopars from The Lindley Collection - Mecum Kissimmee 2023" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
            </Card>
        </>
    )
}

